/* eslint-disable  @typescript-eslint/no-explicit-any */
/**
 *  Thrown if the api status not 'ok' as determined by middleware
 */
export class ResponseNotOk extends Error {
    constructor(response) {
        super();
        const actualProto = new.target.prototype;
        if (Object.setPrototypeOf) {
            Object.setPrototypeOf(this, actualProto);
        }
        else {
            // eslint-disable-next-line no-proto
            this.__proto__ = actualProto;
        }
        this.name = 'ResponseNotOk';
        this.response = response;
        this.status = response.status;
    }
}
/**
 *  Response Middleware that throws a ResponseNotOk Exception if the response status is not
 *  okay or is not in list of expected set of
 *  values.
 * @param options
 * @returns
 */
export function withOkayStatus(options = { statusCodes: new Set() }) {
    // eslint-disable-next-line @typescript-eslint/require-await
    return async ({ response }) => {
        const { statusCodes } = options;
        if (statusCodes.size === 0) {
            // default check
            if (!response.ok) {
                throw new ResponseNotOk(response);
            }
        }
        else if (!statusCodes.has(response.status)) {
            throw new ResponseNotOk(response);
        }
        return response;
    };
}
//# sourceMappingURL=withOkayStatus.js.map